import Container from './ForumListPage.container';
import Component from './ForumListPage';

export default Container(Component);
